import { Injectable } from '@angular/core';
import { Environment, MMobileService } from '@core/services/common';
import { AuthService } from '@core/services/core/auth/auth.service';
import { LogService } from '@core/services/core/log.service';
import { NavigationHelper } from '@core/services/core/navigation-helper.service';
import { BaseMailService } from '@core/services/http-services/base-mail.service';
import { Device } from '@ionic-native/device/ngx';
import { MailMessage, MailMessageRemoteConfig, MailParticularData, SendMessageRequest, SendMessageResponse } from '@models/mail';
import { spinner } from '@utils/rxjs';
import { parseObjectToKeyValueArray } from '@utils/utils';

@Injectable({
  providedIn: 'root'
})
export class DeregisterHelperService {

  constructor(
    private mmobile: MMobileService,
    private baseMailService: BaseMailService,
    private auth: AuthService,
    private nav: NavigationHelper,
    private log: LogService,
    private device: Device,
  ) {}


  sendDeregisterRequest() {
    this.request()
      .pipe(spinner('deregister-form')).subscribe(
      (res: SendMessageResponse) => {
        this.nav.toNew(['deregister', 'result'], { state: {
          success: true,
          referenceNumber: res.dataId
        }
      });
      },
      () => {
        this.nav.toNew(['deregister', 'result'], { state: {
          success: false
        }
      });
      }
    );
  }

  private request() {
    const forms: MailMessageRemoteConfig[] = this.mmobile.getCustomConfig().forms;
    const { user } = this.auth.getState();

    const deregisterFormConfig = forms?.find(f => f.form === 'BAJA_USUARIO_DIGITAL');

    if (!forms || !deregisterFormConfig) {
      const errorMsg = 'It was not possible to retrieve mail config from mmobile, using default values';
      this.log.w(this, errorMsg);
    }

    const msg: MailMessage = {
      mailBoxId: deregisterFormConfig?.mailBoxId ?? '3',
      subject: deregisterFormConfig?.subject ?? 'Valoración Negativa APP METS',
      read: deregisterFormConfig?.read ?? false,
      inboxId: deregisterFormConfig?.inboxId ?? '1',
      sendingFile: false,
      responseModeId: deregisterFormConfig?.responseModeId ?? '3',
      type: deregisterFormConfig?.type ?? '3',
      frmId: deregisterFormConfig?.frmId ?? '639',
      from: user?.email ?? null,
      to: user?.email ?? null,
      content: ''
    };

    const { model, platform, version } = this.device;

    const particularData: MailParticularData[] = parseObjectToKeyValueArray({
      tipoDocumento: user.documentType,
      NIF: user.documentNumber,
      Nombre: user.name,
      'Apellido 1': user.surname1,
      'Apellido 2': user.surname2,
      'Email OIM': user.email,
      Telefono: user.phone,
      'Version de la aplicacion': Environment.config().version,
      Dispositivo: model || navigator.userAgent,
      'Sistema Operativo': this.baseMailService.getOS(platform, version),
      Comentario: 'Solicitud de baja del usuario digital'
    });

    const request: SendMessageRequest = {
      mailboxIdentifier: user.documentNumber,
      particularData,
      message: msg
    };

    return this.baseMailService.sendMessage(request);
  }
}